import { createAsyncThunk } from "@reduxjs/toolkit";

import { getWidget, getWidgets } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchWidgets = createAsyncThunk(
  "widgets/fetchWidgets",
  async (
    params: Partial<{
      projectId: string;
      config: object;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { token } = fetchAuthToken(getState());
    const { adapter } = getState() as AppState;
    const { baseUrl } = adapter.adapter;
    const { projectId, config } = params;

    try {
      const response = await getWidgets(token, baseUrl, projectId, {}, config);

      let { widgets } = response;

      widgets = [...widgets]
        .filter((widget) => !widget.hide)
        .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0));

      return {
        widgets,
        meta: { count: widgets.length }
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchWidget = createAsyncThunk(
  "widgets/fetchWidget",
  async (
    params: Partial<{
      projectId: string;
      widgetId: string;
      config: object;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { token } = fetchAuthToken(getState());
    const { adapter } = getState() as AppState;
    const { baseUrl } = adapter.adapter;
    const { projectId, widgetId, config } = params;

    if (!projectId || !widgetId) {
      return rejectWithValue({ statusText: "Missing project or widget id" });
    }

    try {
      const widget = await getWidget(
        token,
        baseUrl,
        projectId,
        widgetId,
        config
      );

      return { widget };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
